import { Dayjs } from "dayjs";
import clsx from "clsx";
export interface CalendarDayProps {
	text?: number;
	date?: Dayjs;
	selected?: boolean;
	disabled?: boolean;
	onSelected?: (val?: Dayjs) => void;
}
export default function CalendarDay(props: CalendarDayProps) {
	const onClick = () => {
		if (!props.text) return;
		if (props.selected) return;
		if (props.disabled) return;
		props?.onSelected?.(props?.date);
	};

	return (
		<div
			onClick={onClick}
			className={clsx(
				"relative h-0 rounded-full pb-[100%] text-sm font-bold cursor-pointer",
				props.selected && "bg-primary dark:bg-white dark:text-dark text-white",
				props.disabled && "inter-text",
			)}
		>
			<span className="absolute left-1/2 top-1/2" style={{ transform: "translate(-50%, -50%)" }}>
				{props.text}
			</span>
		</div>
	);
}
